{
    "title": "Upload Documents",
    "individualtitle": "Individual Upload Documents",
    "subtitle": "Almost there! Upload these documents below to finish your application",
    "individualsubtitle": "Almost there! Make sure to upload the required documents for the individual",
    "disclaimer": "Please ensure that you upload only live photos of your documents. We do not accept copies or scanned photos.",
    "document":{
        "proofofaddress": "Proof of Address",
        "articlesofincorporation": "Articles of Incorporation",
        "beneficialownershipagreement": "Beneficial Owner Agreement"
    },
    "sections":{
        "proofofaddress": "Proof of Address - Choose one option",
        "subtitle": "Is preferably to upload the BANK STATEMENT",
        "sourceoffunds": "Source of Funds - Choose one option",
        "individualdocuments": "Individual Documents",
        "individualdocumentssubtitle": "The following individuals are missing or need changes for some onboarding required documents. Please upload them."
    },
    "steps":{
        "step1": "Step 1",
        "step2": "Step 2"
    },
    "modal":{
        "title": "Upload Instructions",
        "instructions":{
            "extension": "Only .JPEG and .PDF files are allowed.",
            "livephotos": "Please ensure that you upload only live photos of your documents. We do not accept copies or scanned photos."
        }
    }
}